import { cn } from "@roman/shared/utils";
import type React from "react";

interface IconProps {
  src: string;
  imageSize: {
    width: string;
    height: string;
  };
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ src, imageSize, className }) => {
  return (
    <img
      src={src}
      alt="icon"
      className={cn(`h-[${imageSize.height}px] w-[${imageSize.width}px]`, className)}
      draggable={false}
    />
  );
};
